import Layout from '@/layout';
var dramaRouter = {
  path: '/marketing',
  component: Layout,
  name: 'MarketingDramaRoot',
  children: [{
    path: 'drama',
    component: function component() {
      return import('@/views/marketing/drama/index');
    },
    name: 'MarketingDrama',
    redirect: '/marketing/drama/slot',
    meta: {
      title: '短剧',
      icon: ''
    },
    children: [{
      path: 'slot',
      component: function component() {
        return import('@/views/marketing/drama/slot');
      },
      name: 'DramaSlot',
      meta: {
        title: '短剧广告位',
        icon: '',
        auth: ['admin:drama:slot:list']
      }
    }, {
      path: 'incentive',
      component: function component() {
        return import('@/views/marketing/drama/incentive');
      },
      name: 'DramaIncentive',
      meta: {
        title: '激励规则',
        icon: '',
        auth: ['admin:drama:incentive:detail']
      }
    }, {
      path: 'revenue',
      component: function component() {
        return import('@/views/marketing/drama/revenue');
      },
      name: 'DramaRevenue',
      meta: {
        title: '收益统计',
        icon: '',
        auth: ['admin:drama:revenue:list']
      }
    }]
  }]
};
export default dramaRouter;
export { dramaRouter };